import React from 'react';
import { required, SelectInput, SimpleForm, ReferenceArrayInput, AutocompleteArrayInput, Button, NumberInput, Edit, Create, BooleanInput, EditButton, Filter, List, Datagrid, TextField, TextInput, AutocompleteInput, ReferenceInput, BooleanField } from 'react-admin';
import EditIcon from '@material-ui/icons/Edit';

const ExperimentFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="search_name" alwaysOn resettable />
    </Filter>
);

export const ExperimentList = (props) => (
    <List {...props} filters={<ExperimentFilter />} perPage={25} bulkActionButtons={false}>
        <Datagrid rowClick="edit">
            <TextField source="code" label="ID" />
            <TextField source="name" label="Name" />
            <BooleanField source="active" label="Active" />
            <EditButton variant="contained" color="primary" />
        </Datagrid>
    </List>
);

const ExperimentTitle = ({ record }) => {
    return <span>Experiment {record ? `"${record.name}"` : ''} {record && record.active ? 'ACTIVE' : 'INACTIVE'}</span>;
};

export const ExperimentEdit = (props) => (
    <Edit title={<ExperimentTitle />} {...props}>
    	<SimpleForm>
	        <BooleanInput source="active" label="Active" defaultValue={true} validate={required()}/>
	     	<NumberInput source="code" label="Experiment ID" validate={required()} />
	        <TextInput source="name" label="Experiment Name" style={{ width: '400px' }} validate={required()} />
			<SelectInput label="Experiment Pace" source="pace" 
			    validate={required()}
				allowEmpty 
				helperText="Experiment Pace."
				choices={[
				{ id: 0, name: '1%' },
				{ id: 5, name: '5%' },
				{ id: 10, name: '10%' },
				{ id: 15, name: '15%' },
				{ id: 20, name: '20%' },
				{ id: 25, name: '25%' },
				{ id: 50, name: '50%' },
				{ id: 75, name: '75%' },
				{ id: 80, name: '80%' },
				{ id: 90, name: '90%' },
				{ id: 100, name: '100%' },
			]} />
        </SimpleForm>
    </Edit>
);

export const ExperimentCreate = (props) => (
	 <Create title={<ExperimentTitle />} {...props}>
	 <SimpleForm>
	    <BooleanInput source="active" label="Active" defaultValue={true} validate={required()}/>
	  	<NumberInput source="code" label="Experiment ID" validate={required()} />
	     <TextInput source="name" label="Experiment Name" style={{ width: '400px' }} validate={required()} />
		  <SelectInput label="Experiment Pace" source="pace" 
		    validate={required()}
			allowEmpty 
			helperText="Experiment Pace."
			choices={[
			{ id: 0, name: '1%' },
			{ id: 5, name: '5%' },
			{ id: 10, name: '10%' },
			{ id: 15, name: '15%' },
			{ id: 20, name: '20%' },
			{ id: 25, name: '25%' },
			{ id: 50, name: '50%' },
			{ id: 75, name: '75%' },
			{ id: 80, name: '80%' },
			{ id: 90, name: '90%' },
			{ id: 100, name: '100%' },
		]} />
	 </SimpleForm>
	 </Create>
);